import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow, Checkbox, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { LAST_NAME } from '@/helpers/constants';
import { UserColumnFilters } from '../TableList';
import styles from './UserRow.module.scss';

const useStyles = makeStyles(() => ({
  tableHeaderRow: {
    fontFamily: 'DaimlerCS-Demi',
    fontSize: 14,
    borderRadius: 0,
    padding: '10px',
  },
}));

const columns = [LAST_NAME, 'firstName', 'department', 'userId'];

type UserRowComponent = {
  isHeader?: boolean;
  element?: any;
  isFilter?: boolean;
  isLastRow?: boolean;
  handleRowClick: (element: any) => void;
  handleCheckAll: () => void;
  filterTable?: any;
  columnFilters?: UserColumnFilters;
};

const UserRow: React.FC<UserRowComponent> = ({ isHeader, element, isFilter, isLastRow, handleRowClick, handleCheckAll,
  filterTable, columnFilters }) => {
  const classes = useStyles();
  const handleClick = isHeader ? handleCheckAll : handleRowClick;
  const { t } = useTranslation();

  if (isFilter) {
    return (
      <TableRow className={styles.TableHeaderRow}>
        <TableCell className={classes.tableHeaderRow} />
        {columns.map((col) => (
          <TableCell key={col} className={classes.tableHeaderRow} align="left">
            <TextField
              onChange={(value) => filterTable(col, value)}
              value={columnFilters?.[col] || ''}
              placeholder={t('dialog.filter')}
              variant="standard"
              size="small"
            />
          </TableCell>

        ))}
        <TableCell className={classes.tableHeaderRow} />
      </TableRow>
    );
  }

  if (isHeader) {
    return (
      <TableRow className={styles.TableHeaderRow}>
        <TableCell padding="checkbox">
          <Checkbox color="primary" onClick={handleCheckAll} />
        </TableCell>
        {columns.map((col) => (
          <TableCell key={col} className={classes.tableHeaderRow} align="left">{t(`dialog.${col}`)}</TableCell>
        ))}
        <TableCell className={classes.tableHeaderRow} />
      </TableRow>
    );
  }

  if (typeof element === 'string') {
    return (
      <TableRow>
        <TableCell colSpan={13} align="center">{element}</TableCell>
      </TableRow>
    );
  }

  if (isLastRow) {
    return (
      <TableRow>
        <TableCell colSpan={13} align="center">{t('dialog.moreResults')}</TableCell>
      </TableRow>
    );
  }

  return (
    <TableRow
      key={element.userCode}
      className={styles.TableBodyRow}
      onClick={() => handleClick(element)}
    >
      <TableCell padding="checkbox">
        <Checkbox color="primary" checked={element.selected} />
      </TableCell>
      <TableCell align="left">{element.lastName}</TableCell>
      <TableCell align="left">{element.firstName}</TableCell>
      <TableCell align="left">{element.department}</TableCell>
      <TableCell align="left">{element.userCode}</TableCell>
    </TableRow>
  );
};

export default UserRow;
